// Aviso a recepción: «la habitación 304 quedó lista» (948, hotel.hk_listas_desde).
// Consulta cada 20 s las tareas de limpieza terminadas desde que se abrió la
// pantalla, avisa con un toast y un tono corto, y devuelve las habitaciones que
// quedaron listas en los últimos 10 minutos (el rack las resalta). Varias
// pantallas pueden usarlo a la vez: un registro de módulo evita avisar dos veces.
import { useEffect, useMemo, useRef, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { toast } from 'sonner';
import { QK, hotelRpc } from './shared';

interface Lista { habitacion_id: string; numero: string; camarera: string | null; fin_at: string; llega_hoy: boolean }

const avisadas = new Set<string>();

function tono() {
  try {
    const Ctx = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const o = ctx.createOscillator(); const g = ctx.createGain();
    o.type = 'sine'; o.frequency.value = 880;
    g.gain.setValueAtTime(0.0001, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.2, ctx.currentTime + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.35);
    o.connect(g); g.connect(ctx.destination); o.start(); o.stop(ctx.currentTime + 0.4);
    o.onended = () => void ctx.close();
  } catch { /* sin audio */ }
}

export function useAvisosHabitacionLista(): Set<string> {
  const desde = useRef(new Date().toISOString());
  const [ahora, setAhora] = useState(Date.now());
  const { data = [] } = useQuery<Lista[]>({
    queryKey: [QK, 'hk-listas'],
    queryFn: () => hotelRpc<Lista[]>('hk_listas_desde', { _desde: desde.current }),
    refetchInterval: 20000, staleTime: 0,
  });

  useEffect(() => {
    let nuevas = 0;
    data.forEach((x) => {
      const k = `${x.habitacion_id}|${x.fin_at}`;
      if (avisadas.has(k)) return;
      avisadas.add(k);
      nuevas++;
      toast.success(`Habitación ${x.numero} lista${x.camarera ? ` · ${x.camarera}` : ''}${x.llega_hoy ? ' — tiene llegada hoy' : ''}`, { duration: 8000 });
    });
    if (nuevas) tono();
    setAhora(Date.now());
  }, [data]);

  return useMemo(() => new Set(
    data.filter((x) => ahora - Date.parse(x.fin_at) < 10 * 60 * 1000).map((x) => x.habitacion_id),
  ), [data, ahora]);
}
